import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { roleList } from "../../../services/master";
import { academylist } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import { idcardcount } from "../../../services/student";
import moment from "moment";

export default function Idcarddashboard() {
  const [rlist, setRList] = useState([]);
  const [idtype, setIdType] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [filterProduct, setFilterProduct] = useState([]);
  const [idate, setIdDate] = useState("");

  const [scount, setSCount] = useState("");
  const [tcount, setTCount] = useState("");
  const [wcount, setWCount] = useState("");
  const [ocount, setOCount] = useState("");

  const columnDefs = [
    {
      headerName: "Issued Date",
      field: "idcard_issue_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      },
    },
    {
      headerName: "Role",
      field: "role",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "user",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    setIdDate(moment(new Date()).format("YYYY-MM-DD"));
    roleList().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0],"","");
                
              }
            }
           
          }
        }
      });
    }else{
      listall("", "", "");
    }
    
  }, []);

  function listall(aid, atype, adate) {
    setIdType(atype);
    setIdDate(adate);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("issue_date", adate);
    temp.append("role", atype);

    idcardcount(temp).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.issue_list);
        setSCount(res.data.students);
        setTCount(res.data.teachers);
        setWCount(res.data.workers)
        setOCount(res.data.overall);
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, idtype, idate);
    } else {
      setAcaID("");
      listall("", idtype, idate);
    }

  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">ID Card Dashboard</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>ID Card </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            ID Card Dashboard
          </li>
        </ol>
      </div>
      {localStorage.getItem("Role") === "1" && (
        <div className="card custom-card mg-b-20">
          <div className="card-body">
            <div className="row mt-2">
              <div className="col-xl-3 col-md-3">
                <label className="main-content-label mb-2">ID Cards</label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) => listall(acaid, e.target.value, idate)}
                  value={idtype}
                >
                  <option value="" disabled selected>
                    Select Type
                  </option>
                  {rlist.map((item) => (
                    <>
                      {item.id > 2 && (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      )}
                    </>
                  ))}
                </select>
              </div>

              <div className="col-xl-3 col-sm-6">
                <label className="main-content-label mb-2">
                  Select Academy
                </label>

                <Select
                  className="default-select"
                  placeholder="Select Academy"
                  value={acaid}
                  options={aclist}
                  onChange={handleAcademy}
                  isSearchable={true}
                  isClearable
                  hidden
                />
              </div>

              {/* <div className="col-xl-3 col-sm-3">
              <label className="main-content-label mb-2">Issued Date</label>

              <input
                className="form-control"
                type="date"
                onChange={(e) => listall(acaid, idtype, e.target.value)}
                value={idate}
              />
            </div> */}
            </div>
          </div>
        </div>
      )}

      <div className="row row-sm">
        <div className="col-xl-3 col-md-3">
          <div className="card custom-card">
            <div className="card-bodyy I-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Teachers ID card</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{tcount ? tcount.pending : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted ">Pending</p>
                </div>
              </div>
              <div className="col-md-6 col text-center float-end">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{tcount ? tcount.issued : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted">Issued</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-3">
          <div className="card custom-card">
            <div className="card-bodyy II-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a> Student ID card </a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{scount ? scount.pending : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted ">Pending</p>
                </div>
              </div>
              <div className="col-md-6 col text-center float-end">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{scount ? scount.issued : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted">Issued</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-3">
          <div className="card custom-card">
            <div className="card-bodyy IV-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Workers ID card</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{wcount ? wcount.pending : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted ">Pending</p>
                </div>
              </div>
              <div className="col-md-6 col text-center float-end">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{wcount ? wcount.issued : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted">Issued</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-3">
          <div className="card custom-card">
            <div className="card-bodyy V-st">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-content">
                    <h3 className="title">
                      <a>Over All Cards</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
              <div className="col-md-6 col justify-content-center text-center">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{ocount ? ocount.pending : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted ">Pending</p>
                </div>
              </div>
              <div className="col-md-6 col text-center float-end">
                <h3 className="mb-1 font-weight-bold">
                  {" "}
                  <a>{ocount ? ocount.issued : 0}</a>{" "}
                </h3>
                <div className="d-flex justify-content-center ">
                  <p className="text-muted">Issued</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  Total Issued ID Cards
                </h2>
              </div>

              {localStorage.getItem("Role") !== "1" && (
                <div className="col-xl-3 col-md-3">
                  <label className="main-content-label mb-2">ID Cards</label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => listall(acaid, e.target.value, idate)}
                    value={idtype}
                  >
                    <option value="" disabled selected>
                      Select Type
                    </option>
                    {rlist.map((item) => (
                      <>
                        {item.id > 2 && (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        )}
                      </>
                    ))}
                  </select>
                </div>

              )}
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
